import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { MatStepper } from '@angular/material/stepper';
import { C } from '@fullcalendar/core/internal-common';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { LocationService } from 'src/app/services/location/location.service';
import { UserManagementService } from 'src/app/services/user_management/user-management.service';

@Component({
  selector: 'app-onboarding-company',
  templateUrl: './onboarding-company.component.html',
  styleUrls: ['./onboarding-company.component.scss'],

})
export class OnboardingCompanyComponent {
  firstFormGroup = this._formBuilder.group({
    company_name: ['', Validators.required],
    company_user_role: ['', Validators.required]

  });
  infoFormGroup = this._formBuilder.group({
    phone_number: ['', Validators.required],
    about_us: ['', Validators.required],
    website_url: ['', Validators.required],
    country: ['', Validators.required],
    currency: ['', Validators.required],
    state:['',Validators.required],
    city:['',Validators.required]
  });
  public buisnessIndustry: any[] = []
  public employeeNumber: any[] = [
    { size: '1-10' }, { size: '11-20' }, { size: '21-50' }, { size: '51-100', },
    { size: '101-200' }, { size: '201-500' }, { size: '501-1000', }, { size: '1000+', },
  ];
  public empSize: any;
  public bIndustry!: string;
  public featureArr: any[] = [
    {
      name: 'HR & Skills', all_feature: false, features: [
        { f_name: "Time Management", f_img: "assets/images/onboarding_company/time_management.png", selected: 0 },
        { f_name: "Scheduling", f_img: "assets/images/onboarding_company/scheduling.png", selected: 0 },
        { f_name: "Forecast", f_img: "assets/images/onboarding_company/forecast.png", selected: 0 },
        { f_name: "Payroll-Pay-Rates", f_img: "assets/images/onboarding_company/pay_report.png", selected: 0 },
        { f_name: "Task Management", f_img: "assets/images/onboarding_company/task_manage.png", selected: 0 },
        { f_name: "Contract Signatures", f_img: "assets/images/onboarding_company/contract.png", selected: 0 },
        { f_name: "Management Portals", f_img: "assets/images/onboarding_company/mg_portal.png", selected: 0 },
        { f_name: "Management Reports", f_img: "assets/images/onboarding_company/m_report.png", selected: 0 },
        { f_name: "Compliance", f_img: "assets/images/onboarding_company/compliance.png", selected: 0 },
        { f_name: "Department Manager", f_img: "assets/images/onboarding_company/department.png", selected: 0 },]
    },
    {
      name: 'Communications', all_feature: false, features: [
        { f_name: "Company Forum", f_img: "assets/images/onboarding_company/company_forum.png", selected: 0 },
        { f_name: "Push Notification", f_img: "assets/images/onboarding_company/push.png", selected: 0 },
        { f_name: "Important Notice", f_img: "assets/images/onboarding_company/imp_notice.png", selected: 0 },
        { f_name: "Course Builder", f_img: "assets/images/onboarding_company/course_builder.png", selected: 0 },
        { f_name: "Staff Survey", f_img: "assets/images/onboarding_company/staff_survey.png", selected: 0 },]
    },
    {
      name: 'Operations', all_feature: false, features: [
        { f_name: "Time off Management", f_img: "assets/images/onboarding_company/timeoff.png", selected: 0 },
        { f_name: "Training  Records", f_img: "assets/images/onboarding_company/training.png", selected: 0 },
        { f_name: "Document Management", f_img: "assets/images/onboarding_company/document_management.png", selected: 0 },
        { f_name: "Recognitions & Rewards", f_img: "assets/images/onboarding_company/rewards.png", selected: 0 },
        { f_name: "Live Reporting", f_img: "assets/images/onboarding_company/live_reporting.png", selected: 0 },]
    },
  ]
  files: File[] = [];
  @ViewChild('stepper') private stepper!: MatStepper;

  public selectedFeatures: any[] = []

  public isSecondStepCompleted: boolean = false;
  public isSecondStepClicked: boolean = false;
  public isThirdStepCompleted: boolean = false;
  public isThirdStepClicked: boolean = false;


  countries: any[] = [];
  states: any[] = [];
  cities: string[] = [];
  dropdownSettings: IDropdownSettings = {};
  dropdownSettingsCity: IDropdownSettings = {};
  dropdownSettingsCountry: IDropdownSettings = {};
  constructor(private _formBuilder: FormBuilder, private userManagementService: UserManagementService, private spinner: NgxSpinnerService, private commonService: CommonService,
    private elementRef: ElementRef, private renderer: Renderer2, private appService: AppService, public dialogRef: MatDialogRef<OnboardingCompanyComponent>,
   public locationService:LocationService) { }
  ngOnInit(): void {
    this.countries = this.locationService.getAllCountries();
    this.states = this.locationService.getStatesOfCountry('NG');
    this.cities = this.locationService.getCitiesOfState('NG', 'LA');
    this.buisnessIndustry = [
      {
        img: "assets/images/onboarding_company/recruitment_new.png",
        i_name: "Recruitment"
      },
      {
        img: "assets/images/onboarding_company/hospital.png",
        i_name: "Hospitality"
      },
      {
        img: "assets/images/onboarding_company/food_and_beverage.png",
        i_name: "Food & Beverage"
      },
      {
        img: "assets/images/onboarding_company/warehousing.png",
        i_name: "Warehousing"
      },
      {
        img: "assets/images/onboarding_company/kitchen_Staff.png",
        i_name: "Kitchen Staff"
      },
      {
        img: "assets/images/onboarding_company/other.png",
        i_name: "Other"
      }

    ]

    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.loadScript();
    this.dropdownSettings = {
      idField: 'isoCode',
      textField: 'name',
      singleSelection:true,
      allowSearchFilter: true,
      // below setting will help to enable search filter in multi select dropdown
    };
    this.dropdownSettingsCity = {
      idField: 'isoCode',
      textField: 'name',
      singleSelection:true,
      allowSearchFilter: true,
      // below setting will help to enable search filter in multi select dropdown
    };
    this.dropdownSettingsCountry = {
      idField: 'isoCode',
      textField: 'key',
      singleSelection:true,
      allowSearchFilter: true,
      // below setting will help to enable search filter in multi select dropdown
    };
    this.countries=this.countries.map((key)=>{
      let obj=key
      obj["key"]=obj["flag"]+ " " + obj["name"]
      return obj;
    })
  }
  ngAfterViewInit() {
    // this.stepper._getIndicatorType = () => 'number';
  }

  o() {
    const dropdownElement = this.elementRef.nativeElement.querySelector('.custom-options');
    const dropdownRect = dropdownElement.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    if (dropdownRect.bottom + dropdownRect.height > viewportHeight) {
      this.renderer.addClass(dropdownElement, 'upward');
    }
  }
  onSelect(event: any) {
    if (this.files.length == 0) {
      this.files.push(...event.addedFiles);
    }
    else {
      this.files = [];
      this.files.push(...event.addedFiles);
    }
  }

  onRemove(event: any) {
    this.files.splice(this.files.indexOf(event), 1);
  }

  loadScript() {
    let node = document.createElement('script');
    node.src = "assets/js/custom-select.js";
    node.type = 'text/javascript';
    node.async = true;
    document.getElementsByTagName('head')[0].appendChild(node);
  }
  onFeaturesClick(value: any, item: any) {
    if (value["selected"] == 1) {
      value["selected"] = 0;
      this.selectedFeatures.splice(this.selectedFeatures.findIndex(a => a.f_name === value.f_name), 1)
    }
    else {
      value["selected"] = 1;
      this.selectedFeatures.push(value)
    }
    if (this.selectedFeatures.length > 0) {
      this.isThirdStepCompleted = true;
    }
    else {
      this.isThirdStepCompleted = false;
    }
    // bind checkbox if all values are selected or else unbind
    item["all_feature"] = item["features"].every(feature => feature.selected === 1);
  }

  onCheckBoxValue(item: any, event: any) {
    let newArr: any[] = [];
    newArr = [...item["features"]];
    if (event["checked"] == true) {
      newArr.map((i) => { i["selected"] = 1 });
    }
    else {
      newArr.map(i => { i["selected"] = 0 })
    }
    for (let i = 0; i < newArr.length; i++) {
      this.addOrUpdateFeature(this.selectedFeatures, newArr[i])
    }
  }
  addOrUpdateFeature(selectedFeatureArr, newFeature) {
    const index = selectedFeatureArr.findIndex(feature => feature.f_name === newFeature.f_name);
    if (newFeature.selected === 0) {
      // Remove the object from the array if selected value is 0
      if (index !== -1) {
        selectedFeatureArr.splice(index, 1);
      }
    } else {
      if (index !== -1) {
        // If the object with similar f_name exists, replace it
        selectedFeatureArr[index] = newFeature;
      } else {
        // Otherwise, add the new object to the array
        selectedFeatureArr.push(newFeature);
      }
    }
    if (this.selectedFeatures.length > 0) {
      this.isThirdStepCompleted = true;
    }
    else {
      this.isThirdStepCompleted = false;
    }
  }

  onEmployeeNo(value: any) {
    this.empSize = value["size"]
    this.employeeNumber.map(i => i.selected = value.size == i.size ? true : false);
    if (this.bIndustry && this.empSize) {
      this.isSecondStepCompleted = true;
    }
  }
  onIndustrySelect(value: any) {
    this.bIndustry = value["i_name"]
    this.buisnessIndustry.map(i => i.selected = value.i_name == i.i_name ? true : false);
    if (this.bIndustry && this.empSize) {
      this.isSecondStepCompleted = true;
    }
  }
  onFirstStepperSubmit() {
    if (this.firstFormGroup.invalid) {
      this.firstFormGroup.markAllAsTouched();
    }
  }
  onSecondStepperSubmit() {
    this.isSecondStepClicked = true;
  }
  onThirdStepperSubmit() {
    this.isThirdStepClicked = true;
  }
  onFourthStepperSubmit() { }
  onFifthStepperSubmit() {
    if (this.infoFormGroup.invalid) {
      this.infoFormGroup.markAllAsTouched()
    }
    else {
      this.onSubmit()
    }

  }
  isControlHasError(controlName: string, validationType: string, form: FormGroup): boolean {
    return this.appService.isControlHasError(form, controlName, validationType)
  }

  onSubmit() {
    let newArr: any[] = [];
    for (let i = 0; i < this.featureArr.length; i++) {
      let smallArr = this.featureArr[i].features
      for (let j = 0; j < smallArr.length; j++) {
        let newObj = { feature_name: smallArr[j].f_name, accept: smallArr[j].selected }
        newArr.push(newObj)
      }
    }
    const formData: any = new FormData();
    formData.append("company_name", this.firstFormGroup.value.company_name)
    formData.append('role', this.firstFormGroup.value.company_user_role)
    formData.append('employee_data', this.empSize)
    formData.append('industry_data', this.bIndustry)
    formData.append('feature_data', JSON.stringify(newArr))
    formData.append('company_logo', this.files[0])
    formData.append('phone_number', this.infoFormGroup.value.phone_number)
    formData.append('about_us', this.infoFormGroup.value.about_us)
    formData.append('website_url', this.infoFormGroup.value.website_url)
    formData.append('country', this.infoFormGroup.value.country)
    formData.append('currency', this.infoFormGroup.value.currency)
    formData.append('username', 'john123');
    for (const [key, value] of formData.entries()) {
    }
    this.spinner.show()
    this.userManagementService.onBoardCompany(formData).subscribe({

      next: (response: any) => {
        if (response["status"] == 200) {
          this.spinner.hide();
          this.appService.showToastMessage('success', response["msg"]);
          this.dialogRef.close()
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error)
      }
    })
  }

  onCountry(item){
    // let value=event.target.value;
     this.states=[]
    this.states = this.locationService.getStatesOfCountry(item.isoCode);
  }
  onStates(item){
    // let value=event.target.value;
    let cValue: any= this.infoFormGroup.get('country')?.value;
    if(cValue){
      this.cities=[]
      this.cities = this.locationService.getCitiesOfState(cValue[0].isoCode,item.isoCode);
    }
  }
  onStatesSelect(event:MatSelectChange){
    let cValue: any= this.infoFormGroup.get('country')?.value;
    if(cValue){
      this.cities=[]
      this.cities = this.locationService.getCitiesOfState(cValue,event.value)
    }
  }
  onCountrySelect(event:MatSelectChange){
    this.states=[]
    this.states = this.locationService.getStatesOfCountry(event.value);
  }
}
